import React from "react";
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import { useTranslation } from 'react-i18next';
import '../assets/styles/Project.scss';

function Project() {
  const { t } = useTranslation();

  return (
    <div className="projects-container" id="projects">
      <h1>{t('projects.title')}</h1>
      <div className="projects-grid">
        <div className="project">
          <a href="https://www.filmate.club/" target="_blank" rel="noreferrer">
            <img src={mock10} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a href="https://www.filmate.club/" target="_blank" rel="noreferrer"><h2>Filmate AI</h2></a>
          {/* Project description intentionally not translated - out of scope per i18n spec */}
          <p>Developed movie finder app with semantic search and sentiment analysis using OpenAI GPT-3.5 Turbo, Qdrant, React, and Flask.</p>
        </div>
        <div className="project">
          <a href="https://yujisatojr.itch.io/highspeedchase" target="_blank" rel="noreferrer">
            <img src={mock09} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a href="https://yujisatojr.itch.io/highspeedchase" target="_blank" rel="noreferrer"><h2>High Speed Chase</h2></a>
          {/* Project description intentionally not translated - out of scope per i18n spec */}
          <p>Designed, developed, and launched a 3D multiplayer racing game with C# and Unity. This is available on Itch.io for gamers worldwide to enjoy.</p>
        </div>
      </div>
    </div>
  );
}

export default Project;
